import { IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import BackButton from "../../../../components/BackButton";
import { navigatedToPreviousStep } from "../../../../redux/slice/itemRetrieval/itemRetrievalSlice";
import { RootState } from "../../../../redux/store";

interface StyledIconButtonProps {
  show: boolean;
}

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "show",
})<StyledIconButtonProps>(({ show, theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  color: theme.palette.primary.main,
  display: show ? "flex" : "none",
}));


const ItemRetrievalNavigateBackAction = () => {
  const dispatch = useDispatch();
  const step = useSelector((state: RootState) => state.itemRetrieval.step);

  const showBackButton = step !== 0 && step !== 8;

  const handleBackClick = () => {
    dispatch(navigatedToPreviousStep());
  };

  return <BackButton hidden={!showBackButton} onClick={handleBackClick} />;
};

export default ItemRetrievalNavigateBackAction;
